<template>
    <div class="border-plus">
        <img :src="currentImg" @mouseenter="currentImg = hoverImg" @mouseleave="currentImg = defaultImg" alt="" srcset="">
    </div>
</template>
<script>
export default {
    data () {
        return {
            defaultImg: require('@/assets/img/icon/border_plus.svg'),
            hoverImg: require('@/assets/img/icon/border_plus_hover.svg'),
            currentImg: require('@/assets/img/icon/border_plus.svg')
        }
    }
}
</script>
<style lang="scss"  >
    .border-plus{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/button/borderPlus.vue